import {useFetch} from "../useFetch";
import {VehicleStatus} from "../../types/api/guide/vehicleStatus.types";
import {vehicleStatusService} from "../../services/guide/vehicleStatus-service";

export const useFetchAllVehicleStatus = () => {
    const { isLoading, error, data, refetch } = useFetch<VehicleStatus[]>(vehicleStatusService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
